import SsciCreateEventPage from "./SsciCreateEventPage";

export default SsciCreateEventPage